// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].use[1]!../../../../node_modules/@jetbrains/ring-ui/components/global/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appHeaderWrapper__d2e {
  position: relative;
  width: 100%;
}

.appHeader__ea8 {
  --header-size: calc(var(--ring-unit) * 8);
  display: flex;
  align-items: center;
  box-sizing: border-box;

  height: var(--header-size);

  background-color: var(--ring-navigation-background-color);
  color: var(--ring-text-color);
}

.appHeader__ea8.unauthorized__b25 {
  --header-size: calc(var(--ring-unit) * 9);
}

.appHeader__ea8 .contentWrapper__afc {
  padding: 0 32px;
  height: 100%;
  display: flex;
  align-items: center;
  width: var(--max-page-width);
  box-sizing: border-box;
}

.innerContainer__f4e {
  flex: 1 1 100%;
  display: flex;
  align-items: flex-end;
}

.tray__b88 {
  flex: 0 0 auto;
  height: 100%;
  padding: 0;

  align-items: center;
}

.loginButton__a38 {
  cursor: pointer;
  box-shadow: none;
  height: var(--app-header-height);
  line-height: var(--app-header-height);
  margin-bottom: calc(-1 * var(--ring-unit));

  white-space: nowrap;
}

.clearLinkStyles__f66 {
  color: var(--ring-text-color);

  &:hover {
    color: var(--ring-text-color);
    text-decoration: none;
  }

  &:active {
    color: var(--ring-text-color);
    text-decoration: none;
  }
}

.navLinkContainer__d13 {
  display: flex;
  width: 100%;
}

.loginButton__a38:hover {
  box-shadow: none;
}

.avatar__d7d {
  margin-left: var(--ring-unit);
  height: 100% !important;
  position: relative;
}

.avatar__d7d * {
  cursor: pointer;
}

.avatar__d7d svg {
  vertical-align: middle;
}

.avatarContainer__c98 {
  cursor: pointer;
}

.dropdownUserNameDescription__d84 {
  color: var(--ring-secondary-color);
  font-size: var(--ring-font-size-smaller);
  margin-right: calc(2 * var(--ring-unit));
}

.headerLoader__da7 {
  --tbe-header-loader-height: 4px;

  position: absolute;
  height: var(--tbe-header-loader-height);
  width: 100%;
  transform: translateY(-50%);
  overflow: hidden;
}

.userNameInfo__b93 {
  margin-right: var(--ring-unit);
  vertical-align: middle;
}

.ring-ui-theme-dark .headerLoader__da7 {
  --tbe-header-loader-height: 2px;
}

.headerLoaderInner__f02 {
  position: absolute;
  width: 100%;
  height: 100%;
  animation: loading__bbc 2s infinite cubic-bezier(0.1, 0, 0.9, 1);
}

.headerLoaderInner__f02::before {
  content: '';
  display: block;
  background-image: linear-gradient(
    90deg,
    var(--ring-message-shadow-color),
    var(--ring-main-color),
    var(--ring-link-hover-color),
    var(--ring-main-color),
    var(--ring-message-shadow-color)
  );
  position: absolute;
  top: 0;
  height: calc(var(--tbe-header-loader-height) - 1px);
  width: 60%;
  transform: translateX(-90%);
  opacity: 0.8;
}

.headerLoaderInner__f02::after {
  content: '';
  display: block;
  background-image: linear-gradient(
    90deg,
    var(--ring-popup-background-color),
    var(--ring-main-color),
    var(--ring-link-hover-color),
    var(--ring-main-color),
    var(--ring-popup-background-color)
  );
  position: absolute;
  bottom: 0;
  height: calc(var(--tbe-header-loader-height) - 1px);
  width: 60%;
  transform: translateX(-90%);
  opacity: 0.2;
}

.avatarNotification__aab::before {
  content: '';
  height: var(--ring-unit);
  width: var(--ring-unit);
  border-radius: 50%;
  border: 1px solid white;
  background-color: var(--ring-main-color);
  position: absolute;
  top: 12px;
  right: -4px;
}

.sectionNotification__ca3 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--ring-unit);
  width: var(--ring-unit);
  border-radius: 50%;
  background-color: var(--ring-main-color);
}

@keyframes loading__bbc {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(190%);
  }
}

@media only screen and (min-width: 1600px) {
  .appHeader__ea8 {
    justify-content: center;
  }
}

@media (max-width: 930px) {
  .userNameInfo__b93 {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/common/app-layout/app-header/app-header.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,sBAAsB;;EAEtB,0BAA0B;;EAE1B,yDAAyD;EACzD,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;;EAEV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,qCAAqC;EACrC,0CAA0C;;EAE1C,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;;EAE7B;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;IAC7B,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;;EAE/B,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gEAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,cAAc;EACd;;;;;;;GAOC;EACD,kBAAkB;EAClB,MAAM;EACN,mDAAmD;EACnD,UAAU;EACV,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd;;;;;;;GAOC;EACD,kBAAkB;EAClB,SAAS;EACT,mDAAmD;EACnD,UAAU;EACV,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["@value unit from \"~@jetbrains/ring-ui/components/global/global.css\";\n\n.appHeaderWrapper {\n  position: relative;\n  width: 100%;\n}\n\n.appHeader {\n  --header-size: calc(var(--ring-unit) * 8);\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n\n  height: var(--header-size);\n\n  background-color: var(--ring-navigation-background-color);\n  color: var(--ring-text-color);\n}\n\n.appHeader.unauthorized {\n  --header-size: calc(var(--ring-unit) * 9);\n}\n\n.appHeader .contentWrapper {\n  padding: 0 32px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  width: var(--max-page-width);\n  box-sizing: border-box;\n}\n\n.innerContainer {\n  flex: 1 1 100%;\n  display: flex;\n  align-items: flex-end;\n}\n\n.tray {\n  flex: 0 0 auto;\n  height: 100%;\n  padding: 0;\n\n  align-items: center;\n}\n\n.loginButton {\n  cursor: pointer;\n  box-shadow: none;\n  height: var(--app-header-height);\n  line-height: var(--app-header-height);\n  margin-bottom: calc(-1 * var(--ring-unit));\n\n  white-space: nowrap;\n}\n\n.clearLinkStyles {\n  color: var(--ring-text-color);\n\n  &:hover {\n    color: var(--ring-text-color);\n    text-decoration: none;\n  }\n\n  &:active {\n    color: var(--ring-text-color);\n    text-decoration: none;\n  }\n}\n\n.navLinkContainer {\n  display: flex;\n  width: 100%;\n}\n\n.loginButton:hover {\n  box-shadow: none;\n}\n\n.avatar {\n  margin-left: var(--ring-unit);\n  height: 100% !important;\n  position: relative;\n}\n\n.avatar * {\n  cursor: pointer;\n}\n\n.avatar svg {\n  vertical-align: middle;\n}\n\n.avatarContainer {\n  cursor: pointer;\n}\n\n.dropdownUserNameDescription {\n  color: var(--ring-secondary-color);\n  font-size: var(--ring-font-size-smaller);\n  margin-right: calc(2 * var(--ring-unit));\n}\n\n.headerLoader {\n  --tbe-header-loader-height: 4px;\n\n  position: absolute;\n  height: var(--tbe-header-loader-height);\n  width: 100%;\n  transform: translateY(-50%);\n  overflow: hidden;\n}\n\n.userNameInfo {\n  margin-right: var(--ring-unit);\n  vertical-align: middle;\n}\n\n:global(.ring-ui-theme-dark) .headerLoader {\n  --tbe-header-loader-height: 2px;\n}\n\n.headerLoaderInner {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  animation: loading 2s infinite cubic-bezier(0.1, 0, 0.9, 1);\n}\n\n.headerLoaderInner::before {\n  content: '';\n  display: block;\n  background-image: linear-gradient(\n    90deg,\n    var(--ring-message-shadow-color),\n    var(--ring-main-color),\n    var(--ring-link-hover-color),\n    var(--ring-main-color),\n    var(--ring-message-shadow-color)\n  );\n  position: absolute;\n  top: 0;\n  height: calc(var(--tbe-header-loader-height) - 1px);\n  width: 60%;\n  transform: translateX(-90%);\n  opacity: 0.8;\n}\n\n.headerLoaderInner::after {\n  content: '';\n  display: block;\n  background-image: linear-gradient(\n    90deg,\n    var(--ring-popup-background-color),\n    var(--ring-main-color),\n    var(--ring-link-hover-color),\n    var(--ring-main-color),\n    var(--ring-popup-background-color)\n  );\n  position: absolute;\n  bottom: 0;\n  height: calc(var(--tbe-header-loader-height) - 1px);\n  width: 60%;\n  transform: translateX(-90%);\n  opacity: 0.2;\n}\n\n.avatarNotification::before {\n  content: '';\n  height: var(--ring-unit);\n  width: var(--ring-unit);\n  border-radius: 50%;\n  border: 1px solid white;\n  background-color: var(--ring-main-color);\n  position: absolute;\n  top: 12px;\n  right: -4px;\n}\n\n.sectionNotification {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: var(--ring-unit);\n  width: var(--ring-unit);\n  border-radius: 50%;\n  background-color: var(--ring-main-color);\n}\n\n@keyframes loading {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(190%);\n  }\n}\n\n@media only screen and (min-width: 1600px) {\n  .appHeader {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 930px) {\n  .userNameInfo {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unit": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["unit"]}`,
	"appHeaderWrapper": `appHeaderWrapper__d2e`,
	"appHeader": `appHeader__ea8`,
	"unauthorized": `unauthorized__b25`,
	"contentWrapper": `contentWrapper__afc`,
	"innerContainer": `innerContainer__f4e`,
	"tray": `tray__b88`,
	"loginButton": `loginButton__a38`,
	"clearLinkStyles": `clearLinkStyles__f66`,
	"navLinkContainer": `navLinkContainer__d13`,
	"avatar": `avatar__d7d`,
	"avatarContainer": `avatarContainer__c98`,
	"dropdownUserNameDescription": `dropdownUserNameDescription__d84`,
	"headerLoader": `headerLoader__da7`,
	"userNameInfo": `userNameInfo__b93`,
	"headerLoaderInner": `headerLoaderInner__f02`,
	"loading": `loading__bbc`,
	"avatarNotification": `avatarNotification__aab`,
	"sectionNotification": `sectionNotification__ca3`
};
export default ___CSS_LOADER_EXPORT___;
